import {generatePath} from "react-router-dom";

export const DictionnaireApi = {
  /**   ******   */
  /**   PUBLIC   */
  /**   ******   */
  cgu: {
    url: "/public/cgu",
    getUrl() {
      return this.url;
    },
  },
  sendCodeMail: {
    url: "/public/code/email",
    getUrl() {
      return this.url;
    },
  },
  sendCodeTelephone: {
    url: "/public/code/mobile",
    getUrl() {
      return this.url;
    },
  },
  checkEmail: {
    url: "/public/email",
    getUrl() {
      return this.url;
    },
  },
  labels: {
    url: "/public/labels/:locale",
    getUrl(locale: string) {
      return generatePath(this.url, { locale });
    },
  },
  configuration: {
    url: "public/parametres/configuration",
    getUrl(agence?: string) {
      return agence
        ? `${this.url}?${new URLSearchParams({ agence }).toString()}`
        : this.url;
    },
  },
  /**   ********   */
  /**   FINALIZE   */
  /**   ********   */
  getUser: {
    url: "/finalize/user",
    getUrl(shortId: string | null) {
      return this.url + "?shortId=" + shortId;
    },
  },
  checkCodeMail: {
    url: "/finalize/email",
    getUrl() {
      return this.url;
    },
  },
  checkCodeTelephone: {
    url: "/finalize/mobile",
    getUrl() {
      return this.url;
    },
  },
  setPersonalInfo: {
    url: "/finalize/information",
    getUrl() {
      return this.url;
    },
  },
  rattachement: {
    url: "/finalize/attach",
    getUrl() {
      return this.url;
    },
  },
  /**   *******   */
  /**   USER   */
  /**   *******   */
  user: {
    url: "/user",
    getUrl() {
      return this.url;
    },
  },
  /**   *******   */
  /**   ACCOUNT   */
  /**   *******   */
  account: {
    url: "/account",
    getUrl() {
      return this.url;
    },
  },
  services: {
    url: "/account/services",
    getUrl() {
      return this.url;
    }
  },
  menuGauche: {
    url: "/account/menuGauche",
    getUrl() {
      return this.url;
    }
  },
  bai: {
    url: "/account/bai",
    getUrl() {
      return this.url;
    }
  },
  cybersafe: {
    url: "/account/cybersafe",
    getUrl() {
      return this.url;
    }
  },
  favoris: {
    url: "/account/favoris",
    getUrl() {
      return this.url;
    },
  },
  ajouterFavori: {
    url: "/account/favoris/ajouter",
    getUrl() {
      return this.url;
    },
  },
  supprimerFavori: {
    url: "/account/favoris/supprimer",
    getUrl() {
      return this.url;
    },
  },
  menu: {
    url: "/account/menu",
    getUrl() {
      return this.url;
    },
  },
  historiqueConnexion: {
    url: "/account/connections",
    getUrl() {
      return this.url;
    },
  },
  validateCGU: {
    url: "/account/cgu/validate",
    getUrl() {
      return this.url;
    },
  },
  setPersonalInfoUpdate: {
    url: "/account/information",
    getUrl() {
      return this.url;
    },
  },
  setEmail: {
    url: "/account/email",
    getUrl() {
      return this.url;
    },
  },
  mobile: {
    url: "/account/mobile",
    getUrl() {
      return this.url;
    },
  },
  setPassword: {
    url: "/account/password",
    getUrl() {
      return this.url;
    },
  },
  /**   ********   */
  /**   FACTURES   */
  /**   ********   */
  getFactures: {
    url: "/factures",
    getUrl() {
      return this.url;
    },
  },
  downloadFacture: {
    url: "/factures/:id",
    getUrl(id: number) {
      return generatePath(this.url, { id: String(id) });
    },
  },
  paymentLink: {
    url: "/factures/:id/paymentLink",
    getUrl(id: number) {
      return generatePath(this.url, { id: String(id) });
    },
  },
  updatePaymentStatus: {
    url: "/factures/:id/updatePaymentStatus",
    getUrl(id: number) {
      return generatePath(this.url, { id: String(id) });
    },
  },
  /**   ********   */
  /**   DOCUMENTS  */
  /**   ********   */
  getDocuments: {
    url: "/documents",
    getUrl() {
      return this.url;
    },
  },
  downloadDocument: {
    url: "/documents/:id",
    getUrl(id: number) {
      return generatePath(this.url, { id: String(id) });
    },
  },

  /**   ********   */
  /**   CONTACT    */
  /**   ********   */
  contactServiceListService: {
    url: "/contact-service/list-services-a-contacter/locale/:locale/agence/:agence",
    getUrl(locale: string, agence: string) {
      return generatePath(this.url, { locale, agence });
    },
  },

  contactServiceUser: {
    url: "/contact-service/user",
    getUrl() {
      return this.url;
    },
  },
  contactServiceAffilie: {
    url: "/contact-service/affilie/uuidEmployeur/:uuidEmployeur",
    getUrl(uuidEmployeur: string) {
      return generatePath(this.url, { uuidEmployeur });
    },
  },
  /**   ********   */
  /**    ADMIN     */
  /**   ********   */
  adminGetServices: {
    url: "/admin/services",
    getUrl() {
      return this.url;
    },
  },
  adminSetService: {
    url: "/admin/services/:id",
    getUrl(id: string) {
      return generatePath(this.url, { id });
    },
  },
  adminGetPublicites: {
    url: "/admin/pubmep",
    getUrl() {
      return this.url;
    },
  },
  adminSetPublicites: {
    url: "/admin/pubmep/:id",
    getUrl(id: string) {
      return generatePath(this.url, { id });
    },
  },
  adminGetAccessGroups: {
    url: "/admin/accessGroups",
    getUrl() {
      return this.url;
    },
  },
  adminCreateAccessGroups: {
    url: "/admin/accessGroups",
    getUrl() {
      return this.url;
    },
  },
  adminSetAccessGroups: {
    url: "/admin/accessGroups/:id",
    getUrl(id: string) {
      return generatePath(this.url, { id });
    },
  },

  /**   ********   */
  /**    AUTRE     */
  /**   ********   */
  authorizedAffilies: {
    url: "/affilie/authorizedAffilies",
    getUrl() {
      return this.url;
    },
  },

  logoutURL: {
    url: "/logout",
    getUrl() {
      return this.url;
    },
  },
};
